export default __webpack_public_path__ + "static/media/ar-benefit.556adfd3.svg";